import api from './../api';
import request from "../utils/requestToJavaServer";
export function Account_Login({ username, password }: any) {
    return new Promise((resolve, reject) => {
        request.post(api.accountApi.ACCOUNT_LOGIN, { username, password }).then((res) => {
            resolve(res)
        }).catch((err) => {
            reject(err)
        })
    });
}

export function Account_Register({ user, code }: any) {
    return new Promise((resolve, reject) => {
        request.post(api.accountApi.ACCOUNT_REGISTER, { user, code }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Account_Logout() {
    return new Promise((resolve, reject) => {
        request.post(api.accountApi.ACCOUNT_LOGOUT).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Account_Logoff() {
    return new Promise((resolve, reject) => {
        request.post(api.accountApi.ACCOUNT_LOGOFF).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Account_Password(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.accountApi.ACCOUNT_PASSWORD, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}